// components/EquipmentData.js
import React, { useEffect, useState } from 'react';
// import styled from 'styled-components';
import { TextField, Stack, Autocomplete } from '@mui/material';
import { inicializarIndicesSeguro, calcularValoresSeguro, formatarMoeda } from '../../../utils/seguroUtils';

const styleTextField = {
  backgroundColor: 'white',
  width: '30vw',
  '@media screen and (max-width: 600px)': {
    width: '70vw', // Width de 100% para telas de celulares
  },
};

const anos = [
  { id: 1, nome: '1 Ano' },
  { id: 2, nome: '2 Anos' },
  { id: 3, nome: '3 Anos' },
  { id: 4, nome: '4 Anos' },
  { id: 5, nome: '5 Anos' },
];
const parcelas = [
  { id: 1, nome: 'A Vista' },
  { id: 2, nome: '2 Vezes' },
  { id: 3, nome: '3 Vezes' },
  { id: 4, nome: '4 Vezes' },
];

function SeguroData({ formData, setFormData, dadosImportados }) {
  useEffect(() => {
    const fetchIndices = async () => {
      await inicializarIndicesSeguro()
    }
    fetchIndices()
  }, [])

  useEffect(() => {
    if (formData.valorProjeto > 0 && formData.negociacao?.anos?.id && formData.negociacao?.parcelas?.id) {
      const { valorTotal, valorParcela } = calcularValoresSeguro(
        formData.valorProjeto,
        formData.negociacao.anos.id,
        formData.negociacao.parcelas.id
      );
      // Atualiza o estado da proposta com os valores calculados
      setFormData((prev) => ({
        ...prev,
        valorSeguro: valorTotal,
        valorParcela,
      }));

      return
    }
    setFormData((prev) => ({
        ...prev,
        valorSeguro: 0,
        valorParcela: 0,
      }));
  }, [formData.negociacao, formData.valorProjeto, setFormData]);
  return (
    <div>
      <Stack
        direction={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        flex={1}
        gap={2}
        backgroundColor={'white'}
        padding={8}
        borderRadius={2}
      >
        <TextField
          disabled={dadosImportados || formData.visualiza}
          id="valorProjeto"
          label="Valor Projeto"
          inputProps={{ type: 'number' }}
          variant="outlined"
          sx={styleTextField}
          value={formData.valorProjeto}
          onChange={(event) => {
            setFormData((prev) => ({
              ...prev,
              valorProjeto: event.target.value === '' ? null : parseFloat(event.target.value),
            }));
          }}
        />
        <Autocomplete
          disabled={dadosImportados || formData.visualiza}
          disablePortal
          id="anos"
          value={formData.negociacao?.anos || null}
          options={anos}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${option.nome}`}
          sx={{ ...styleTextField, marginBottom: 2 }}
          renderInput={(params) => <TextField {...params} label="Anos" />}
          onChange={(event, newValue) => {
            setFormData((prev) => ({
              ...prev,
              negociacao: { ...prev.negociacao, anos: newValue },
            }));
          }}
        />

        <Autocomplete
          disabled={dadosImportados || formData.visualiza}
          disablePortal
          id="parcelas"
          value={formData.negociacao?.parcelas || null}
          options={parcelas}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${option.nome}`}
          sx={{ ...styleTextField, marginBottom: 2 }}
          renderInput={(params) => <TextField {...params} label="Parcelas" />}
          onChange={(event, newValue) => {
            setFormData((prev) => ({
              ...prev,
              negociacao: { ...prev.negociacao, parcelas: newValue },
            }));
          }}
        />

        <TextField
          disabled
          id="valor"
          label="Valor Total"
          variant="outlined"
          sx={styleTextField}
          value={(formData.valorSeguro || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || ''}
        />

        <TextField
          disabled
          id="valor"
          label="Valor Parcela"
          variant="outlined"
          sx={styleTextField}
          value={(formData.valorParcela || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || ''}
        />
      </Stack>
    </div>
  );
}

export default SeguroData;
